import { produce } from 'immer'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const asBuilder = <T>(factory: () => T) => {
  const builder = (recipe?: (base: T) => void): T => {
    const base = factory()
    return recipe ? produce(base, recipe) : base
  }
  return builder
}
